<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12Ubctk/tc-custom/9781567926873.jpg?1701632361264" alt="This image is the cover for the book Diary of a Pint-Sized Farmer"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Diary of a Pint-Sized Farmer
      </h1>
      <p class="bookDescription body article font2">
        <b>One woman’s humorous memoir about leaving the corporate world behind for life on a northern England farm with her whole family. </b><br/><br/>Ever dream of reinventing yourself and starting over? Sally Urwin did. Even though her feet don’t quite reach the tractor pedals, this city-girl-turned-shepherd found happiness and love with one husband, two kids, grumpy rams, ewes and lambs, Mavis the Sheepdog, and a very fat pony.<br/><br/>Once employed to market the insolvency services of a large accounting firm, Sally along with her husband, Steve, now run High House Farm in Northumbria. Built around 1840, High House is a working farm where the whole family (including two children) pitches in. In a fresh and funny voice all her own, Sally tells her story of the shepherding life?which at High House also includes the sideline businesses of a tearoom, winery, and a barn for weddings.<b></b><br/><br/><i>Diary of a Pint-Sized Farmer</i> reveals the highs and lows of the shepherding life and the hard work in making a living from the land. Filled with grit and humor, eccentric animals, and local characters, this is the perfect book for anyone who has ever wondered what it’s like to pack up and find a new life on the other side of the fence.<br/><br/><b>Praise for <i>Diary of a Pint-Sized Farmer</i></b><br/><br/><b>“Urwin’s account of a year on High House Farm, with its mix of arable land and 200 sheep in windswept Northumbria, is no rural idyll. But it’s full of passion for the realities of life lived knee-deep in the countryside. . . . Despite the hardships, Urwin still finds the fun in rural life.” —<i>Daily Mail</i></b><br/><br/><b>“A wonderfully honest and comic account of what life on a farm is really like.” —<i>Living</i></b><br/><br/><b>“With her witty humor and candid descriptions, it’s hard not to fall in love with Sally.” ?<i>Countryman’s Weekly</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sally Urwin
      </h2>
      
      <p class="authorDescription body article"><B>Sally Urwin</B> is (probably) the shortest farmer in England and lives with her family and a lot of sheep in Northumberland. She used to work in the most depressing job in the world—marketing manager for a bankruptcy practitioner—but made a bid for freedom after nabbing farmer Steve from the Dating Direct website in 2001.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David R. Godine
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3c1c4d6d